<script>
	import RoamEvents from "./roamEvents";
	import { getContext, onMount, onDestroy } from "svelte";
	import GrsDevices from "./grsDevices";
	import ReplayTimelineHandler from './replayTimeline'

	const flightContext = getContext('flight')
	let flight
	let replayStore
	let timelineHandler
	let roams
	let grs
	let grsDevicesStore

	onMount(() => {
		flight = flightContext.get()
		replayStore = flight.replayInfoStore
		timelineHandler = flight.getHandler(ReplayTimelineHandler)
		roams = flight.getHandler(RoamEvents)
		grs = flight.getHandler(GrsDevices)
		grsDevicesStore = grs.store
	})
	onDestroy(() => {
		flight.releaseHandler(ReplayTimelineHandler)
		flight.releaseHandler(RoamEvents)
		flight.releaseHandler(GrsDevices)
	})
</script>

<div>
	{#each ($roams || []) as roam}
		<div
			class="roamDot"
			style={`left: ${timelineHandler.timeToPercent(roam.timestamp, $replayStore.currentLiveTimestamp) * 100}%;`}
		>
			{#if $grsDevicesStore[roam.currentId]}
				<div
					data-tooltip={`Roam to ${$grsDevicesStore[roam.currentId].name}`}
					class="tooltip"
				/>
			{/if}
		</div>
	{/each}
</div>

<style>
	.tooltip {
		width: 100%;
		height: 100%;
		position:relative;
	}

	.roamDot {
		position: absolute;
		height: 10px;
		width: 10px;
		background-color: #5189e1;
		border-radius: 50%;
		display: inline-block;
		border: 1px solid white;
		margin-top: -2px;
	}
</style>
